import * as Sentry from "@sentry/vue"

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const sentryConfig = config.public.sentry || {}

  if (!sentryConfig.dsn) {
    return
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: sentryConfig.dsn,
    environment: sentryConfig.environment,
    release: sentryConfig.release,
    tracesSampleRate: sentryConfig.tracesSampleRate,
    tracePropagationTargets: [
      /^https:\/\/ticketsmile\.com\.br/,
      /^https:\/\/www\.ticketsmile\.com\.br/,
      /^https:\/\/api\.ticketsmile\.com\.br/,
      /^http:\/\/localhost:\d+/,
      /^\/api\//,
    ],
    replaysSessionSampleRate: sentryConfig.replaysSessionSampleRate,
    replaysOnErrorSampleRate: sentryConfig.replaysOnErrorSampleRate,
    integrations: [
      Sentry.browserTracingIntegration({
        router: useRouter(),
      }),
      Sentry.replayIntegration(),
    ],
  })

  nuxtApp.vueApp.config.errorHandler = (err, _instance, info) => {
    Sentry.captureException(err, { extra: { info } })
    console.error('[Vue error]', err)
  }

  return {
    provide: { sentry: Sentry },
  }
})
